export default __webpack_public_path__ + "static/media/pokemon_ghost.ac4d9e01.png";